// src/elements/List/context.ts
import { createContext } from "react";
var ListContext = createContext({
  variant: "disc",
  icon: "chevron-right"
});
export { ListContext };